module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usertype-history-force-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v(_vm._s(_vm.$t('User List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Usertype History Force Edit')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Usertype History Force Edit')))])]), _c('div', {
    staticClass: "col-sm-3"
  })]), (_vm.loading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [_c('p', [_c('img', {
    staticClass: "img-rounded",
    staticStyle: {
      "width": "auto",
      "max-height": "200px"
    },
    attrs: {
      "src": _vm.userImage
    },
    on: {
      "click": function($event) {
        _vm.onClickImageModalShow(_vm.user)
      }
    }
  })]), _c('h4', [_vm._v(_vm._s(_vm.user.user_name) + "　" + _vm._s(_vm.user.user_firstname)), _c('br'), _vm._v("（" + _vm._s(_vm.user.user_name_furigana) + " " + _vm._s(_vm.user.user_firstname_furigana) + " ）")]), _c('p', {
    staticClass: "profile"
  }, [_vm._v("性別 : " + _vm._s(_vm.user.user_sex)), _c('br'), _vm._v("生年月日 : " + _vm._s(_vm.user.user_birthday_format)), _c('br'), _vm._v("年齢 : " + _vm._s(_vm.user.user_age) + " 歳")])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h3', [_vm._v("役職異動履歴（変更前）")]), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', [_vm._v("役職異動前")]), _c('th', [_vm._v("役職異動後")]), _c('th', [_vm._v("異動日付")])])]), _vm._l((_vm.usertypeHistories), function(usertypeHistory) {
    return _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(usertypeHistory.attributes['user-type-name-before']))]), _c('td', [_vm._v(_vm._s(usertypeHistory.attributes['user-type-name-after']))]), _c('td', [_vm._v(_vm._s(usertypeHistory.attributes['change-day-format']))])])])
  })], 2)]), _c('div', {
    staticClass: "col-sm-1"
  }), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h3', [_vm._v("役職異動履歴（変更後）")]), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("役職異動前")]), _c('th', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("役職異動後")]), _c('th', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("異動日付        "), _c('a', {
    staticClass: "btn btn-violet btn-sm",
    on: {
      "click": function($event) {
        _vm.sortHistory()
      }
    }
  }, [_vm._v("並べ替え")])]), _c('th', {
    staticStyle: {
      "vertical-align": "middle",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        _vm.addHistory()
      }
    }
  }, [_vm._v("行追加")])])])]), _vm._l((_vm.localUserTypeHistories), function(localUserTypeHistory, index) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (localUserTypeHistory.user_type_id_before),
        expression: "localUserTypeHistory.user_type_id_before"
      }],
      staticClass: "form-control",
      class: {
        required: !_vm.validation.user_type_id_before[index]
      },
      on: {
        "change": [function($event) {
          localUserTypeHistory.user_type_id_before = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        }, function($event) {
          _vm.setUserTypeName('before', index)
        }]
      }
    }, [_c('option'), _vm._l((_vm.usertypes), function(user_type) {
      return _c('option', {
        domProps: {
          "value": user_type.id
        }
      }, [_vm._v(_vm._s(user_type.attributes['user-type-name']))])
    })], 2), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.validation.user_type_id_before[index]),
        expression: "!validation.user_type_id_before[index]"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (localUserTypeHistory.user_type_id_after),
        expression: "localUserTypeHistory.user_type_id_after"
      }],
      staticClass: "form-control",
      class: {
        required: !_vm.validation.user_type_id_after[index]
      },
      on: {
        "change": [function($event) {
          localUserTypeHistory.user_type_id_after = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          })[0]
        }, function($event) {
          _vm.setUserTypeName('after', index)
        }]
      }
    }, [_c('option'), _vm._l((_vm.usertypes), function(user_type) {
      return _c('option', {
        domProps: {
          "value": user_type.id
        }
      }, [_vm._v(_vm._s(user_type.attributes['user-type-name']))])
    })], 2), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.validation.user_type_id_after[index]),
        expression: "!validation.user_type_id_after[index]"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('td', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_c('el-date-picker', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (localUserTypeHistory.change_day),
        expression: "localUserTypeHistory.change_day"
      }],
      class: {
        required: !_vm.validation.change_day[index]
      },
      attrs: {
        "placeholder": "yyyy-mm-dd",
        "picker-options": localUserTypeHistory.pickerOptionsChangeDate
      },
      domProps: {
        "value": (localUserTypeHistory.change_day)
      },
      on: {
        "input": function($event) {
          localUserTypeHistory.change_day = $event
        }
      },
      nativeOn: {
        "change": function($event) {
          _vm.checkChangeDate($event, index)
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.validation.change_day[index]),
        expression: "!validation.change_day[index]"
      }],
      staticClass: "validation-msg"
    }, [_vm._v("今日以前を入力ください。")])], 1), _c('td', {
      staticStyle: {
        "vertical-align": "middle",
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.deleteHistory(index)
        }
      }
    }, [_vm._v("行削除")])])])])
  })], 2)])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onClickSave
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v("保存")])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.onClickCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v("キャンセル")])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49cda7dc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/usertype-history-force-edit.pug
// module id = 815
// module chunks = 1